import { defineComponent as _defineComponent } from 'vue'
import type { BoundedTextElement } from '@/typings/customilyElements/canvasElements';
import type { CanvasEx } from '@/typings/canvas';
import ShadowSettings from '@/components/DesignStudio/ShadowSettings.vue';
import { useShadowSettings } from '@/composables/shadowSettings';


export default /*#__PURE__*/_defineComponent({
  __name: 'TextShadowProperties',
  props: {
    canvas: null,
    textElement: { default: undefined },
    editMode: { type: Boolean },
    cmykMode: { type: Boolean },
    isPreview: { type: Boolean, default: false },
    exportFormat: null
  },
  emits: ["shadow-change", "open-shadow-color-library-selector"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'shadow-change'): void;
    (e: 'open-shadow-color-library-selector'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { canvas: CanvasEx, textElement: BoundedTextElement, editMode?: boolean, cmykMode?: boolean, isPreview: boolean, exportFormat?: string };

/**
 * Shadow panel of a bounded text. Everything that is not specific to a text lives in
 *  useShadowSettings + ShadowSettings: this only says which element to write into, and when a text
 *  can't cast a shadow.
 */




const shadow = useShadowSettings<BoundedTextElement>({
    element: () => props.textElement,
    canvas: () => props.canvas,
    editMode: () => props.editMode,
    exportFormat: () => props.exportFormat,
    // A textured text paints the texture over the glyphs, there is no silhouette left to cast
    supportsShadow: (element) => element.type === 'bounded-text' && !element.texture,
    openLibrarySelector: () => emit('open-shadow-color-library-selector'),
    onShadowChange: () => emit('shadow-change')
});

return { __sfc: true,props, emit, shadow, ShadowSettings }
}

})